import {ArrowLeft} from 'lucide-react'
import { useNavigate } from 'react-router-dom'

function Shop() {
  const navigate = useNavigate()

  return (
    <div className="min-h-screen bg-gradient-to-b from-cyan-50 via-sky-50 to-blue-50 flex flex-col">
      {/* Floating Paw Prints Background */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none opacity-10">
        <div className="absolute top-20 left-10 text-6xl animate-bounce" style={{ animationDelay: "0s", animationDuration: "3s" }}>&#x1f43e;</div>
        <div className="absolute top-40 right-20 text-5xl animate-bounce" style={{ animationDelay: "1s", animationDuration: "4s" }}>&#x1f43e;</div>
        <div className="absolute bottom-40 left-1/4 text-4xl animate-bounce" style={{ animationDelay: "2s", animationDuration: "3.5s" }}>&#x1f43e;</div>
        <div className="absolute top-1/3 right-1/4 text-6xl animate-bounce" style={{ animationDelay: "0.5s", animationDuration: "4.5s" }}>&#x1f43e;</div>
        <div className="absolute bottom-20 right-10 text-5xl animate-bounce" style={{ animationDelay: "1.5s", animationDuration: "3s" }}>&#x1f43e;</div>
      </div>

      {/* Header */}
      <header className="bg-white/90 backdrop-blur-md shadow-lg border-b-4 border-cyan-400 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-20">
            <div className="flex items-center gap-3">
              <img 
                src="https://static.lumi.new/a7/a763f43bfb7facec581a9f81e634eb57.webp" 
                alt="Shikoku Inu Logo"
                className="w-12 h-12 rounded-full shadow-lg transform hover:rotate-12 transition-transform object-cover"
              />
              <span className="text-2xl font-black text-gray-800">
                SHIKOKU <span className="text-cyan-500">INU</span>
              </span>
            </div>

            <button
              onClick={() => navigate('/')}
              className="flex items-center gap-2 px-4 py-2 rounded-lg bg-cyan-500 text-white hover:bg-cyan-600 transition-colors font-black shadow-lg"
            >
              <ArrowLeft size={20} />
              <span>Back to Home</span>
            </button>
          </div>
        </div>
      </header>

      {/* Coming Soon Content */}
      <div className="flex-1 flex items-center justify-center px-4 py-20 relative">
        <div className="text-center max-w-2xl mx-auto">
          <div className="mb-8">
            <img 
              src="https://static.lumi.new/dd/dd864277d8f1a429aec7b33dd068decd.webp" 
              alt="Shikoku Inu"
              className="w-40 h-40 sm:w-52 sm:h-52 mx-auto drop-shadow-2xl object-contain"
            />
          </div>
          <h1 className="text-4xl sm:text-6xl font-black text-gray-800 mb-4 leading-tight">
            <span className="text-cyan-500">Shikoku</span> Store
          </h1>
          <div className="inline-block bg-gradient-to-r from-cyan-400 to-sky-500 text-white text-2xl sm:text-3xl font-black px-8 py-4 rounded-full shadow-xl mb-8 animate-pulse">
            Coming Soon!
          </div>
          <p className="text-lg sm:text-xl text-gray-600 font-bold max-w-lg mx-auto">
            Official $SHINU merch is on the way! Stay tuned for the goodest boi gear on the blockchain. 🐾
          </p>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-gradient-to-r from-cyan-500 via-sky-500 to-blue-500 text-white py-12 px-4 relative">
        <div className="max-w-6xl mx-auto">
          <div className="text-center space-y-6">
            <div className="flex items-center justify-center gap-3 mb-4">
              <img 
                src="https://static.lumi.new/a7/a763f43bfb7facec581a9f81e634eb57.webp" 
                alt="Shikoku Inu Logo"
                className="w-16 h-16 rounded-full shadow-lg object-cover"
              />
              <span className="text-4xl font-black">SHIKOKU INU</span>
            </div>
            <p className="text-xl font-bold max-w-2xl mx-auto">
              Join our pack and be part of the most adorable crypto revolution!
            </p>
            <div className="pt-8 border-t-2 border-white/30">
              <p className="font-bold">&copy; 2026 Shikoku Inu Coin. All rights reserved.</p>
              <p className="text-sm mt-2 opacity-80">
                $SHINU is a meme coin with no intrinsic value or expectation of financial return. This is for entertainment purposes only. DYOR!
              </p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  )
}

export default Shop
